import { API_URI } from "@saleor/config";
import { couponUnlockCodeBulkUpload } from "@saleor/coupons/mutations";
import { couponAddUnlockCodesUrl } from "@saleor/coupons/url";
import { createUploadLinkWithProgress } from "@saleor/utils/createUploadLinkWithProgress";
import { InMemoryCache } from "apollo-cache-inmemory";
import ApolloClient from "apollo-client";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

let progressHandler = _percent => ({});

const client = new ApolloClient({
  link: createUploadLinkWithProgress({
    uri: API_URI,
    onProgress: p => progressHandler(p)
  }),

  cache: new InMemoryCache()
});

const setUploadProgressListener = cb => {
  progressHandler = cb;
};

const useBulkUploadMutation = (couponId: string) => {
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [isBulkMutationLoading, setIsBulkMutationLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [isRedirecting, setIsRedirecting] = useState(false);

  const handleBulkUploadMutation = useCallback((file: File) => {
    setIsBulkMutationLoading(true);
    setErrorMessage("");
    setUploadProgressListener(p => setProgress(p));
    client
      .mutate({
        mutation: couponUnlockCodeBulkUpload,
        variables: { file }
      })
      .then(response => {
        if (
          response.data.couponUnlockCodeBulkUploadAndExtract.discountErrors
            .length > 0
        ) {
          setErrorMessage(
            response.data.couponUnlockCodeBulkUploadAndExtract.discountErrors[0]
              .message
          );
        } else {
          setProgress(100);
          setIsRedirecting(true);
          setTimeout(() => {
            navigate(couponAddUnlockCodesUrl(couponId), {
              state: {
                unlockCodes:
                  response.data.couponUnlockCodeBulkUploadAndExtract.unlockCodes
              }
            });
          }, 1000);
        }
      })
      .finally(() => {
        setIsBulkMutationLoading(false);
      });
  }, []);

  const handleClearErrorMessageFromApi = useCallback(() => {
    setErrorMessage("");
    setProgress(0);
  }, []);

  return {
    handleBulkUploadMutation,
    isBulkMutationLoading,
    errorMessage,
    handleClearErrorMessageFromApi,
    progress,
    isRedirecting
  };
};

export default useBulkUploadMutation;
